export default __webpack_public_path__ + "static/media/NewPRY.181a4793.png";